export const state = {
  visible: true,
}

export const getters = {
  visible: state => state.visible,
}

// dispatch
export const actions = {
  populateFromDB: async ({ commit, dispatch, state }, payload) => {},

  toggleNavbar: async ({ commit }) => {
    commit('TOGGLE')
  }
}

// commit
export const mutations = {
  TOGGLE: (state) => {
    state.visible = !state.visible
  }
}
